export default __webpack_public_path__ + "static/media/schedule_call_flower_footer.e5972c1f.webp";